import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5ba9944c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba9944c')) {
      api.createRecord('5ba9944c', component.options)
    } else {
      api.reload('5ba9944c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=5ba9944c", function () {
      api.rerender('5ba9944c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/users/edit.vue"
export default component.exports